<app-launch-field-container [basespaceFormControl]="formControl">
    <rad-text-field
    class="rad-theme--light"
    [formControl]="formControl"
    [attr.disabled]="formControl.disabled || null"
    [attr.minlength]="formControl.minLength"
    [attr.maxlength]="formControl.maxLength"
    [attr.error]="formControl.errors?.required || formControl.basespaceErrors.length > 0"
    [attr.size]="formControl.size"
    (focus)="onFocus()"
    (blur)="onBlur()"
    ></rad-text-field>
</app-launch-field-container>

